'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {
	return {
		// update access_token in aptiConfig
		updateAccessToken: function(data) {
			apiConfig.refreshAccessToken(data);
		},

		// refresh_access_token resource
		token: $resource(
				sCgiBin + '/rest.refresh_access_token', 
				{
					id: sessionID
				},
				{
					// renew: ask for new access_token
					renew: {
						method: 'POST'
					}
				}
			),
		// calculate the refreshInterval based von access_token creationTime and expires_in seconds
		refreshInterval: function() { 

			// convert seconds to milliseconds
			var expireIn = parseInt(apiConfig.$get().accessTokenExpiresIn) * 1000;

			// substract 5% from expire_in time
			var refreshIn = expireIn - expireIn * 0.05;
			
			// if interval is less than 30 seconds, set interval to 2 seconds, to start requesting a new access_token
			if(refreshIn < 30000)
				return 2000;
			else
				return refreshIn;
		}
	}
}
